/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zhuxuxi
 * @Date: 2023-05-09 17:40:50
 * @LastEditTime: 2023-08-14 14:17:55
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/main',
    redirect: '/front-page',
    component: () => import('@/views/main'),
    children: [
      {
        // 首页
        path: '/front-page',
        component: () => import('@/views/main/front-page')
      },
      {
        // 福鼎预报
        path: '/fu-ding',
        component: () => import('@/views/main/other-prediction/fu-ding')
      },
      {
        // 霞浦预报
        path: '/xia-pu',
        component: () => import('@/views/main/other-prediction/xia-pu')
      },
      {
        // 海洋预报
        path: '/ocean-forcast',
        component: () => import('@/views/main/ocean-forcast')
      },
      {
        // 灾害警报
        path: '/disaster-alert',
        component: () => import('@/views/main/disaster-alert')
      },
      {
        // 滨海旅游
        path: '/coastal-tourism',
        component: () => import('@/views/main/coastal-tourism')
      },
      {
        // 渔业保障预报
        path: '/fishery-security',
        component: () => import('@/views/main/fishery-security')
      },
      {
        // 水乡渔村
        path: '/fish-village',
        component: () => import('@/views/main/fish-village')
      },
      {
        // 水乡渔村详情页
        path: '/fish-village/:id',
        component: () => import('@/views/main/fish-village/detail')
      },
      {
        // 海洋科普宣传
        path: '/ocean-science',
        component: () => import('@/views/main/ocean-science')
      },
      {
        // 海洋科普宣传
        path: '/ocean-science/:id',
        component: () => import('@/views/main/ocean-science/detail')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    component: () => import('../views/not-found/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
